export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7885663769cb6e9d3104ef1f1b42e5eb.jpg"
          alt="Professional Car Detailing"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl mx-auto w-full">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 tracking-tight leading-tight">
          Precision Detailing.<br />Lasting Protection.
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-8 sm:mb-10 font-light max-w-3xl mx-auto px-4">
          Professional automotive care that restores, protects, and elevates every vehicle.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:space-x-6 sm:gap-0 px-4">
          <button
            onClick={() => scrollToSection('contact')}
            className="w-full sm:w-auto bg-[#1A1A1A] text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-sm sm:text-base font-medium hover:scale-105 transition-transform duration-300 whitespace-nowrap cursor-pointer"
          >
            Book Your Detail
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className="w-full sm:w-auto border-2 border-white text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-sm sm:text-base font-medium hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            View Services
          </button>
        </div>
      </div>
    </section>
  );
}
